export interface AdequacyScore {
  score: number;
  scoreChange?: number;
  gaps: number;
  noneMetCount: number;
  accessOnlyMetCount: number;
  servicingOnlyMetCount: number;
  gapsChange?: number;
}

export interface ChartData {
  totalInvalidVerifications: number;
  invalidVerificationsByType: Array<{
    invalidVerifications: number;
    invalidVerificationType: string;
  }>;
}

export const verificationColors = [
  "#1c5382",
  "#033d7a",
  "#0163c8",
  "#087ef9",
  "#3094fc",
  "#82bfff",
  "#8fb4dd",
  "#e6f1fc",
  "#346086",
  "#afd6ff",
  "#d9ebff",
];
